import I18n from "../../I18n";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { snakeCaseToPascalCase } from "../../utils";
import { Buffer } from "buffer";
import { prepareSeverityByStatus } from "../../utils/auditNoteSeverityConverter";
import { formatValueByType } from "./utils/formatValueByType";
import { extractEntityName, hasJsonStructure } from "./utils/mapperUtils";

const mapCard = (json) => {
    const {
        TypeByField,
        EntityName,
        EntityID,
        DataFile,
        AuditStatusTotal,
        id,
        AuditStatus,
        ImportIDFindings,
    } = json;
    const entityType = (EntityName || "").split("::").pop();

    const result = Object.keys(TypeByField)
        .map((item) => {
            const tempItem = item.replace("T", "F");
            return [
                {
                    label: tempItem,
                    ...formatValueByType(
                        json,
                        json[tempItem],
                        TypeByField[item].type,
                        TypeByField[item].options,
                        TypeByField[item].defaultValue,
                        TypeByField[item].mask,
                    ),
                    align:
                        TypeByField[item] && TypeByField[item].align
                            ? TypeByField[item].align
                            : "left",
                    basis: TypeByField[item].basis,
                },
            ];
        })
        .filter((filter) => filter);

    const colbiDDField = snakeCaseToPascalCase(entityType, "CDM_", "s");
    const idToUse = hasJsonStructure(EntityID)
        ? EntityID
        : JSON.stringify({ [`${colbiDDField}.ID`]: EntityID });

    const entityToUse = hasJsonStructure(EntityID) ? extractEntityName(EntityID) : entityType;
    const linkObj = {
        labels: ["Refers Id"],
        value: {
            id: Buffer.from(idToUse).toString("base64"),
            name: I18n.translate`${entityType}`,
            __typename: `${entityToUse}`,
        },
        type: "object",
        align: "center",
    };

    if (EntityName === "File") {
        linkObj.value[`link`] = {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/activity/status/?filter=${stringifyFilter(
                [{ column: "ID", filters: [{ value: `${json.ImportID}` }] }],
            )}`,
        };
    }
    result.push([linkObj]);
    result.push([
        { labels: ["file"], value: DataFile || ImportIDFindings, type: "string", align: "left" },
    ]);

    const replacedAuditStatus = AuditStatus.replaceAll(" ", "-");
    const { family, severity } = prepareSeverityByStatus((replacedAuditStatus || "").toLowerCase());
    result.push([
        {
            labels: ["audit status"],
            value: {
                value: AuditStatus.toLowerCase(),
                label: I18n.translate`${AuditStatus}`,
                severity: severity,
                family,
                color: "main",
            },
            type: "status",
            align: "center",
        },
    ]);

    result.push([
        {
            labels: "audit notes",
            value: {
                id: id,
                name: AuditStatusTotal,
                customComponent: "PushAuditNote",
            },
            justify: "left",
        },
    ]);

    return result;
};

const header = (json) => {
    const headerMapping = Object.keys(json).map((elem) => {
        if (json[elem]) {
            const { name: label, align, basis } = json[elem];
            return { label: [label], align: align ? align : "left", basis };
        } else {
            return undefined;
        }
    });
    headerMapping.push({ label: ["reference"], align: "left", type: "object" });
    headerMapping.push({ label: ["file"], align: "left" });
    headerMapping.push({ label: ["audit status"], align: "left", type: "status", basis: "15%" });
    headerMapping.push({ label: ["audit notes"], align: "left", type: "customComponent" });
    return headerMapping;
};

const mapper = (json, card) => {
    return {
        ...json,
        __typename: json.__typename,
        card: card ? mapCard(json).filter((elem) => elem.length !== 0) : [],
    };
};

const ncfindingMapper = {
    map: mapper,
    header,
    showCheckbox: true,
};

export default ncfindingMapper;
